import http from "../utils/http";
import { toast } from "../utils/toast";

// 연장 근무 신청 등록
export const postRequestWorkExtend = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/request/extend", params)
      .then((res) => {
        toast.success('연장근무 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        toast.error('연장근무 신청에 실패했습니다.')
        reject(err);
      });
  });
};

// 휴일 근무 신청 등록
export const postRequestWorkHoliday = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/request/holiday", params)
      .then((res) => {
        toast.success('휴일근무 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        toast.error('휴일근무 신청에 실패했습니다.')
        reject(err);
      });
  });
};

// 출퇴근 내역 변경 신청 등록
export const postRequestWorkHistory = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/request/history", params)
      .then((res) => {
        toast.success('출퇴근 시간 정정 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        toast.error('출퇴근 시간 정정 신청에 실패했습니다.')
        reject(err);
      });
  });
};

